module.exports = __webpack_public_path__ + "static/dmon-018-26e6b02a1367348ecf5a660509f5b628.jpg";